/* Ankerlink #shop-the-routine → Section „Shop the Routine“ auf der Startseite (The Impact Agency) */
(function () {
  var ID = 'shop-the-routine';
  var OFFSET = 90; // Abstand für den Sticky-Header
  function section() { return document.querySelector('[id$="__shoppable_buy_all_UGNVU3"]'); }
  function go(smooth) {
    var s = section();
    if (!s) return false;
    var top = s.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var l = e.target.closest('a[href$="#' + ID + '"]');
    if (!l || !section()) return;
    e.preventDefault();
    go(true);
    history.replaceState(null, '', '#' + ID);
  });
  function init() { if (location.hash === '#' + ID) setTimeout(function () { go(false); }, 300); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
